import React from 'react';

import {useComments} from 'app/comments/api';
import {SidebarItem} from 'app/general/structures/SidebarItem';
import {gt, ngt} from 'app/utils/i18n';

import type {CommentContentType} from 'sweet-types';

type Props = {
  link?:
    | string
    | {
        pathname: string;
        search?: string;
        hash?: string;
        state?: Record<string, unknown>;
      }
    | (() => string);
  active?: boolean;
  objectId: number;
  onClick: (ev: React.SyntheticEvent<unknown>) => void;
  forceTooltipShow: boolean;
  contentType: CommentContentType;
};

export const CommentsSidebarItem = ({
  contentType,
  objectId,
  ...other
}: Props) => {
  const numComments =
    useComments({
      object_pk: objectId,
      content_type: contentType,
    }).data?.count || 0;

  return (
    <SidebarItem
      title={
        numComments > 0
          ? ngt('%s comment', '%s comments', numComments)
          : gt('No comments')
      }
      icon="far fa-comments"
      badge={numComments > 0 ? numComments : undefined}
      {...other}
    />
  );
};
